/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { providers, router } from "dc-core";

const redirectToFile = assetId => {
  if (assetId) {
    const redirectUrl = `/link/file/?uri=${assetId}`;
    router.history.push(router.withQueryParams(redirectUrl));
  }
};

export const showFileCopyDialog = () => {
  providers.selection().then(selectionFactory => {
    const selectionProvider = selectionFactory.registerSelection("preview");
    const selectedItems = selectionProvider.selectedItems;
    if (selectedItems && selectedItems.length) {
      const selectedItem = selectedItems[0];
      const assetId = selectedItem.asset_id;
      selectionProvider
        .copyFileDialog({
          assetId,
          dropinId: "preview",
          showError: true
        })
        .then(copyAssetId => {
          const newAssetId = copyAssetId || assetId;
          redirectToFile(newAssetId);
        });
    }
  });
};
